import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

const OrderDescription = ({ isGiftReturn }) => {
  const { t } = useTranslation()

  return (
    <Text type="bodyMRegular">
      {isGiftReturn
        ? t(
            'Introduce los datos del pedido original del regalo para comenzar. Es posible que tengas que pedir esta información a la persona que te hizo el regalo.'
          )
        : t('Introduce los datos de tu pedido para iniciar el proceso')}
      .
    </Text>
  )
}

export default OrderDescription
